import React from 'react';
import Video from './Video';
import ProfileImage from '../Common/ProfileImage'
import { getLocalUserDetails, initialNameHandle } from '../../Helpers/Chat/User';
import { capitalizeFirstLetter } from '../../Helpers/Utility';
import {
    CALL_BUSY_STATUS_MESSAGE, CALL_ENGAGED_STATUS_MESSAGE,
    CALL_STATUS_DISCONNECTED, CALL_STATUS_ENGAGED, CALL_STATUS_HOLD,
    CALL_HOLD_STATUS_MESSAGE, CALL_STATUS_BUSY, CALL_STATUS_CONNECTED, CALL_STATUS_CALLING, CALL_STATUS_CONNECTING, CALL_STATUS_RINGING, CALL_STATUS_ENDED,
} from '../../Helpers/Call/Constant';
import { AudioOffHoc, IconPinActiveHoc, IconPinHoc, VideoOffHoc } from '../../assets/images';
import {getFromLocalStorageAndDecrypt} from '../../Helpers/Chat/webChatEncryptDecrypt';
import Audio from './Audio';
import { handleAudioClasses } from '../../Helpers/Call/Call';
import { store } from '../../Redux/store';
import { pinUserData } from '../../Redux/feature/pinUserDataSlice';

const SmallVideo = (props) => {
    let pinUserDatas = {};
    
    const setPinUser = (e, userJid) => {
        e.stopPropagation();
        if (!props.setPinUser) return;
        const state = store.getState();
        pinUserDatas = state.pinUserData;
        userJid = userJid && pinUserDatas.userJid !== userJid ? userJid : null;
        store.dispatch(pinUserData(userJid));
    }
    const indicator = false;

    let { videoMuted, audioMuted, stream, rosterData, pinUserJid, userStatus, inverse } = props;
    let displayName = rosterData.displayName !== undefined && rosterData.displayName !== null ? rosterData.displayName : rosterData.nickname;
    let jid = (rosterData.username) ? rosterData.username : rosterData.fromUser;
    let vcardData = getLocalUserDetails();
    let muted = false;
    if (jid === vcardData.fromUser) {
        muted = true;
    }
    const token = getFromLocalStorageAndDecrypt('token');
    let userStatusDisplay = "";
    if (userStatus && userStatus.toLowerCase() !== CALL_STATUS_CONNECTED) {
        if (userStatus.toLowerCase() === CALL_STATUS_BUSY) {
            userStatusDisplay = CALL_BUSY_STATUS_MESSAGE;
        } else if (userStatus.toLowerCase() === CALL_STATUS_ENGAGED) {
            userStatusDisplay = CALL_ENGAGED_STATUS_MESSAGE;
        } else if (userStatus.toLowerCase() === CALL_STATUS_HOLD) {
            userStatusDisplay = CALL_HOLD_STATUS_MESSAGE;
        } else if (userStatus.toLowerCase() === CALL_STATUS_CALLING) {
            userStatusDisplay = capitalizeFirstLetter(userStatus.toLowerCase())
        } else if (userStatus.toLowerCase() === CALL_STATUS_CONNECTING) {
            userStatusDisplay = capitalizeFirstLetter(userStatus.toLowerCase())
        } else if (userStatus.toLowerCase() === CALL_STATUS_RINGING) {
            userStatusDisplay = capitalizeFirstLetter(userStatus.toLowerCase())
        } else if (userStatus.toLowerCase() === CALL_STATUS_DISCONNECTED) {
            userStatusDisplay = capitalizeFirstLetter(userStatus.toLowerCase())
        } else if (userStatus.toLowerCase() === CALL_STATUS_ENDED) {
            userStatusDisplay = capitalizeFirstLetter(CALL_STATUS_DISCONNECTED)
        }
    }

    let pinClass = "RemoteVideo-contianer ";
    if (props.setPinUser && pinUserJid === props.jid) {
        pinClass = pinClass + "pin-user";
    }

    const getInitalName = (rosterDataVal) => {
        const localUser = rosterDataVal.fromUser === vcardData.fromUser;
        if (localUser) return vcardData.nickName;
        else return rosterDataVal.initialName;
    }
        const initialName = initialNameHandle(rosterData, getInitalName(rosterData));
    return(
        <span
            key={props.elKey}
            style={props.tileViewStyle}
            className={`${pinClass}${userStatus && userStatus.toLowerCase() !== CALL_STATUS_CONNECTED ? " user-connecting" : ""}`}
            onClick={(e) => setPinUser(e, props.jid)}>
            {(videoMuted || !stream.video || (props.callStatus && props.callStatus.toLowerCase() === CALL_STATUS_DISCONNECTED)) &&
            <>
                <ProfileImage
                name={initialName}
                chatType='chat'
                userToken={token}
                temporary={false}
                imageToken={rosterData.thumbImage !== "" ? rosterData.thumbImage : rosterData.image}
                />
            </>
            } 
            <span className="ParticipantInfo">{displayName}</span>
            {stream && stream.video && !videoMuted && props.callStatus &&
            props.callStatus.toLowerCase() !== CALL_STATUS_DISCONNECTED && <Video stream={stream.video} muted={muted} id={stream.video.id} inverse={inverse} />}
            {stream && stream.screenshare && props.callStatus &&
            props.callStatus.toLowerCase() !== CALL_STATUS_DISCONNECTED && <Video stream={stream.screenshare} muted={muted} id={stream.screenshare.id} inverse={inverse} />}
            {stream && stream.audio && <Audio stream={stream.audio} muted={muted} id={stream.audio.id} />}
            <div className="remoteCallStatus">
                {audioMuted &&
                    <i title="Participant is muted" className="AudioOffRemote"><AudioOffHoc viewBox = '0 0 19.144 20.207' /></i>
                }
                <>
                {indicator &&
                    <div className={`audio_indication left height_adjust transistion_adjust  ${handleAudioClasses(60)}`}>
                    <div className="audio_indicator audio_indicator_1"></div>
                    <div className="audio_indicator audio_indicator_2"></div>
                    <div className="audio_indicator audio_indicator_3"></div>
                </div>
                }
                </>
                {videoMuted &&
                    <i title="Participant has stopped the camera" className="videoOffRemote"><VideoOffHoc viewBox = '0 0 13.802 12.882'/></i>
                }
            </div>
            {!props.tileView && (
                <>
                    {props.setPinUser && (
                    <>
                        {pinUserJid === props.jid ? (
                            <i onClick={(e) => setPinUser(e, props.jid)} className="pinned active">
                                <IconPinActiveHoc viewBox = '0 0 5.713 10.628' />
                            </i>
                    ) : (
                        <i onClick={(e) => setPinUser(e, props.jid)} className="pinned">
                            <IconPinHoc viewBox = '0 0 5.713 10.628' />
                        </i>
                    )}
                    </>
                    )}
                </>
            )}
            {userStatus && userStatusDisplay !== "" && userStatus.toLowerCase() !== CALL_STATUS_CONNECTED &&
                <div className="overlay-text">
                    {userStatusDisplay}
                </div>
            }
        </span>
    )}

export default SmallVideo;
